<template>
  <v-app v-if="loggedIn && OtpVerified">
    <v-navigation-drawer class="cms-nav" persistent clipped v-model="drawer" enable-resize-watcher fixed app>
      <v-list>
        <v-list-item color="primary darken-2" value="true" v-for="(item, i) in items" :key="i" :to="item.link">
          <v-list-item-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-item-action>
          <v-list-item-content>
                <v-list-item-title class="d-flex">
              <span v-text="item.title"></span>
              <span v-if="item.title == 'Waybills' && showBadge == true" class="red-dot"></span>

            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <a href="https://www.napconational.com" target="_blank"><img src="@/assets/smartphoenix-logo.png" alt="SmartPhoenix SAL" class="sp-logo"/></a>
    </v-navigation-drawer>

    <v-app-bar app clipped-left class="edit-item-header" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Napco Truck Tracking Platform</v-toolbar-title>
      <div style="margin-left:2%;">
      <span style="font-style:italic" v-if="user.userRoleId==1">Main Administration Dashboard</span>
      <span style="font-style:italic" v-if="user.userRoleId==5">Freight Forwarder Account</span>
      <span style="font-style:italic" v-if="user.userRoleId==3">Client Account</span> 
      </div>

      <v-spacer></v-spacer>
      <v-progress-circular v-if="$store.getters.globalLoading" indeterminate></v-progress-circular>
      <v-menu close-on-content-click>
        <template v-slot:activator="{ on }">
          <v-badge
            :content="entities['notification'].length"
            :color="entities['notification'].length > 0 ? 'red' : 'transparent'"
            top right
            offset-y="50%"
            offset-x="50%"
          >
            <v-btn color="primary" icon v-on="on">
              <v-icon>mdi-bell</v-icon>
            </v-btn>
          </v-badge>  
        </template>
        <v-list class="pt-5">
          <v-list-item 
            v-for="(notification, index) in entities['notification']"
            :key="`notification_${index}`"
          >
            <v-icon color="primary" class="mr-2">mdi-alert</v-icon>
            <v-list-item-title class="primary--text">
              <strong>{{ notification.message }}</strong>
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="goNotifications()">View All</v-list-item>
        </v-list>
      </v-menu>
      <v-menu close-on-content-click>
        <template v-slot:activator="{ on }">
            <span style="color: #0B5596;">{{user.userFullName}}</span>
          <v-btn icon v-on="on">
            <v-icon color="primary">mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list class="pt-0">
          <v-list-item>
            <v-icon color="primary" class="mr-2">mdi-account-circle</v-icon>
            <v-list-item-title class="primary--text">
              <strong style="color: #0B5596;">{{ user.userFullName }}</strong>
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="showEditProfile = true">
            <v-icon class="mr-2">mdi-account-box-outline</v-icon>
            <v-list-item-title>
              Profile
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-icon class="mr-2">logout</v-icon>
            <v-list-item-title>
              Logout
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content>
      <router-view/>
    </v-content>

    <user-edit :user="user" v-model="showEditProfile"/>
    <v-alert
      v-model="alert_new_approved_waybill"
      dismissible
      type="success"
      top
      center
      width="50%"
      style="z-index:10000;margin:auto; position:absolute;top:70px;left:25%"
    >
      A Waybill has been activated 
    </v-alert>
    <v-alert
      v-model="alert_new_waybill"
      dismissible
      type="warning"
      top
      center
      width="50%"
      style="z-index:10000;margin:auto; position:absolute;top:70px;left:25%"
    >
      A Waybill request has been added 
    </v-alert>
    <v-alert
      v-model="alert_new_violation"
      dismissible
      type="error"
      top
      center
      width="50%"
      style="z-index:10000;margin:auto; position:absolute;top:70px;left:25%"
    >
      A new violation is detected 
    </v-alert>
  </v-app>
  <v-app v-else-if="loggedIn && OtpVerified == false ">
    <v-content v-if="$route.name.includes('privacy')">
      <v-app-bar app clipped-left color="primary" dark>
        <v-toolbar-title>Napco Truck Tracking Platform</v-toolbar-title>
      </v-app-bar>
      <router-view/>
    </v-content>
    <v-content v-else class="align-center background">
      <otp></otp>
    </v-content>
  </v-app>
  <v-app v-else>
    <v-content v-if="$route.name.includes('privacy')">
      <v-app-bar app clipped-left color="primary" dark>
        <v-toolbar-title>Napco Truck Tracking Platform</v-toolbar-title>
      </v-app-bar>
      <router-view/>
    </v-content>
    <v-content v-else class="align-center background">
      <login></login>
    </v-content>
    <!-- <v-snackbar color="primary" v-model="snackbar">
      Unable to connect to server. Please refresh to retry.
    </v-snackbar> -->
  </v-app>
</template>

<script>
import Login from "@/views/_Login";
import Otp from "@/views/Otp";
import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapActions } from 'vuex';
import UserEdit from '@/components/UserEdit'
import Store from '@/store'
import request from './store/helpers'

export default {
  data() {
    return {
      drawer: true,
      showBadge: false,
      snackbar: false,
      showEditProfile: false,
      alert_new_approved_waybill:false,
      alert_new_waybill:false,
      alert_new_violation:false,
      notification_badge_counter:0
    }
  },
  components: { Login, Otp, UserEdit },
  computed: {
    ...mapState('settings',['settings']),
    ...mapState('users',['loggedIn','OtpVerified','user']),
    ...mapState('entities',['entities']),
    items() {
      let menulst = [];
      if(this.user!==undefined && this.user.userRoleId==1){
        menulst=[
        { title: 'Dashboard', icon: 'mdi-poll-box', link: '/' },
        { title: 'Waybills', icon: 'mdi-package-variant-closed', link: '/waybills' },
        { title: 'Drivers', icon: 'mdi-crosshairs', link: '/drivers' },
        { title: 'Trucks', icon: 'mdi-truck', link: '/trucks' },
        { title: 'Users', icon: 'mdi-account-multiple', link: '/users' },
        { title: 'Freight Fowarders', icon: 'mdi-account-multiple', link: '/freightforwarders' },
        { title: 'Addresses Data', icon: 'mdi-pin', link: '/addresses' },
        { title: 'Delivery Addresses', icon: 'mdi-pin', link: '/deliveryAddresses' },
        { title: 'Notifications', icon: 'mdi-alert', link: '/NotificationsDetailed' },
        { title: 'Settings', icon: 'settings', link: '/settings' },
        // { title: 'Languages', icon: 'mdi-flag', link: '/languages' },
        //{ title: 'Mobile Phones', icon: 'mdi-phone', link: '/phones' },
        //{ title: 'Contact Tickets', icon: 'mdi-ticket', link: '/contactTickets' },
      ];
      }else if(this.user!==undefined && this.user.userRoleId==5){
        menulst=[
        { title: 'Dashboard', icon: 'mdi-poll-box', link: '/' },
        { title: 'Waybills', icon: 'mdi-package-variant-closed', link: '/waybills' },
        { title: 'Drivers', icon: 'mdi-crosshairs', link: '/drivers' },
        { title: 'Trucks', icon: 'mdi-truck', link: '/trucks' },
        { title: 'Notifications', icon: 'mdi-alert', link: '/NotificationsDetailed' },
        // { title: 'Languages', icon: 'mdi-flag', link: '/languages' }, 
        ];
      }else{
        menulst=[
        { title: 'Dashboard', icon: 'mdi-poll-box', link: '/' },
        { title: 'Waybills', icon: 'mdi-package-variant-closed', link: '/waybills' },
        { title: 'Drivers', icon: 'mdi-crosshairs', link: '/drivers' },
        { title: 'Trucks', icon: 'mdi-truck', link: '/trucks' },
        { title: 'Freight Fowarders', icon: 'mdi-account-multiple', link: '/freightforwarders' },
        { title: 'Delivery Addresses', icon: 'mdi-pin', link: '/deliveryAddresses' },
      ];
      }
        return menulst;
      /*
      return (this.user !== undefined && this.user.userRoleId == 1)? [
        { title: 'Dashboard', icon: 'mdi-poll-box', link: '/' },
        { title: 'Languages', icon: 'mdi-flag', link: '/languages' },
        { title: 'Users', icon: 'mdi-account-multiple', link: '/users' },
        { title: 'Waybills', icon: 'mdi-package-variant-closed', link: '/waybills' },
        { title: 'Addresses Data', icon: 'mdi-pin', link: '/addresses' },
        { title: 'Delivery Addresses', icon: 'mdi-pin', link: '/deliveryAddresses' },
        { title: 'Drivers', icon: 'mdi-crosshairs', link: '/drivers' },
        { title: 'Notifications', icon: 'mdi-alert', link: '/notifications' },
        { title: 'Mobile Phones', icon: 'mdi-phone', link: '/phones' },
        { title: 'Trucks', icon: 'mdi-truck', link: '/trucks' },
        { title: 'Contact Tickets', icon: 'mdi-ticket', link: '/contactTickets' },
        { title: 'Settings', icon: 'settings', link: '/settings' },
      ] : [
        { title: 'Dashboard', icon: 'mdi-poll-box', link: '/' },
        { title: 'Trucks', icon: 'mdi-truck', link: '/trucks' },
        { title: 'Delivery Addresses', icon: 'mdi-pin', link: '/deliveryAddresses' },
        { title: 'Waybills', icon: 'mdi-package-variant-closed', link: '/waybills' },
      ]
*/
    }
  },
  methods: {
    ...mapActions('users',['initialize','logout']),
    ...mapActions('settings',['getSettings']),
    ...mapActions('entities',['getEntities','getPaginatedEntities']),
    showNewWaybillNotification() {
      this.alert_new_waybill = true
      this.showBadge = true
    }, 
    showApprovedWaybillNotification() {
      this.alert_new_approved_waybill = true
    },
    showViolationNotification(){
      this.alert_new_violation = true
      this.notification_badge_counter ++
      this.getPaginatedEntities('notification')
    },
    goNotifications(){ 
      this.$router.push('NotificationsDetailed')
    },
    getWaybills({commit}) {
      request({
        commit: commit, method: 'get', url: `waybill/list`, successCallback: entities => {
          //console.log(entities)
          var payload = { entities: entities, name: name }

          if (entities.some(e => e.waybillStatus == 'Active')) {
            this.showBadge = true
          } else {
            this.showBadge = false
          }
        }
      });
    }
  },
  created() {
    this.initialize()
    this.getSettings().catch(error => {
      this.snackbar = true;
    })
    this.getEntities('language')

  },
  mounted() { 
    console.log(this.$route)
    this.$driverHub.$on('cms_new_waybill',this.showNewWaybillNotification)
    this.$driverHub.$on('cms_active_waybill',this.showApprovedWaybillNotification)

    this.getWaybills("waybill");
    
  }
}
</script>
<style lang="scss">
@import 'style/style.scss';

.background {
  background-image: url("assets/background.svg");
  background-size: cover;
  background-position: center;
}

.cms-nav {
  & > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .sp-logo {
    width: 100%;
    height: 86px;
    padding: 16px 48px;
  }
}

.red-dot {
  width: 6px;
  height: 6px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  margin-left: 4px;
  align-self: flex-start;
}
</style>